import { CreditReport } from "types/landlord/reports";
import { formatToCurrency } from "utils/currency";
import { Section } from "views/applications-id-report/components/Section";

interface CollectionsSummaryProps {
  collections?: CreditReport["collections"];
  isNoHit: boolean;
}

export const CollectionsSummary = ({
  isNoHit,
  collections
}: CollectionsSummaryProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Collections summary">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Collections summary" maxWidth="none">
      <div className="w-full">
        {collections?.length && collections.length > 0 ? (
          <>
            {/* Table header */}
            <div className="flex w-full border-b border-alpha-40">
              <div className="w-full max-w-[470px] py-3.5">
                <p className="text-sm font-medium text-content-300">Company</p>
              </div>
              <div className="w-[140px] shrink-0  py-3.5">
                <p className="text-sm font-medium text-content-300">Amount</p>
              </div>
              <div className="flex w-2/5 justify-end py-3.5">
                <p className="text-sm font-medium text-content-300">
                  Classification
                </p>
              </div>
            </div>

            {/* Table body */}
            {collections.map((item) => {
              return (
                <div
                  className="flex w-full border-b border-alpha-40"
                  key={item.client_name}
                >
                  <div className="w-full max-w-[470px] py-3.5">
                    <p className="text-sm font-medium text-content-1000">
                      {item.client_name || "N/A"}
                    </p>
                  </div>
                  <div className="w-[140px] shrink-0 py-3.5">
                    <p className="text-sm font-medium text-content-1000">
                      {item.balance?.cents
                        ? formatToCurrency({
                            cents: item.balance.cents,
                            currency: "USD"
                          })
                        : "N/A"}
                    </p>
                  </div>
                  <div className="flex w-2/5 justify-end py-3.5">
                    <p className="text-sm font-medium capitalize text-content-1000">
                      {item.creditor_classification?.description || "N/A"}
                    </p>
                  </div>
                </div>
              );
            })}
          </>
        ) : (
          <p className="text-base font-medium">No data available</p>
        )}
      </div>
    </Section>
  );
};
